import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { ISafetyCaseAction, IUseDeleteMutation, IGetDeleteRequest, IDeleteFn } from '../../interfaces'
import config from '../../config'

const getDeleteSafetyCaseActionMutationRequest: IGetDeleteRequest = () => ({
  method: 'delete',
  url: `${config.baseUrl}/sms/SafetyCaseActions/`,
})

const useDeleteSafetyCaseActionMutation: IUseDeleteMutation<ISafetyCaseAction, number> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getDeleteSafetyCaseActionMutationRequest(params), [params])

  const deleteSafetyCaseAction: IDeleteFn<ISafetyCaseAction> = useCallback(
    async id => axios({ ...request, url: request.url + id }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseAction, Error, any>({ mutationFn: deleteSafetyCaseAction, ...options })

  return response
}

export default useDeleteSafetyCaseActionMutation
